'use client'

import ActivateSCContainer from 'pageContainers/ActivateSCPage'

export default function ActivateSC() {
  return <ActivateSCContainer />
}
